// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10J7G","importantInfo":"styles_importantInfo__7X2iz"};